import type { GlobalTypes } from '@modules';

export enum RateTypesEnum {
  buy = 'buy',
  sell = 'sell',
}

export type GETRateParams = {
  from: GlobalTypes.CurrencyEnum;
  to: GlobalTypes.CurrencyEnum;
  type: RateTypesEnum;
};

export type GETRateResponse = {
  from: GlobalTypes.CurrencyEnum;
  to: GlobalTypes.CurrencyEnum;
  type: RateTypesEnum;
  rate: string;
};

export enum TransactionStatusesEnum {
  new = 'new',
  pending = 'pending',
  paid = 'paid',
  order_scheduled = 'order_scheduled',
  order_failed = 'order_failed',
  payment_failed = 'payment_failed',
  failed_exchange = 'failed_exchange',
  descriptor_failed = 'descriptor_failed',
  cancelled = 'cancelled',
  not_found = 'not_found',
  failed_deposit = 'failed_deposit',
  failed_payout = 'failed_payout',
  completed = 'completed',
  order_verified_not_complete = 'order_verified_not_complete',
}

export enum GoTransactionStatusesEnum {
  new = 'new',
  pending = 'pending',
  cancelled = 'cancelled',
  paid = 'paid',
  order_failed = 'order_failed',
  order_scheduled = 'order_scheduled',
  failed_exchange = 'failed_exchange',
  descriptor_failed = 'descriptor_failed',
  succeeded = 'succeeded',
  failed = 'failed',
  sending = 'sending',
  completed = 'completed',
  limit_exceeded = 'limit_exceeded',
}

// wallet

export type GETWalletParams =
  | {
      fiat_currency?: GlobalTypes.FiatCurrencyEnum;
    }
  | undefined;

export type GETWalletResponse = {
  [key in GlobalTypes.CryptoCurrencyEnum]: {
    created_at: string;
    updated_at: string;
    created_at_ts: number;
    updated_at_ts: number;
    currency: GlobalTypes.CryptoCurrencyEnum;
    percent: string;
    balance: string;
    fiat_currency: GlobalTypes.FiatCurrencyEnum;
    fiat_balance: string;
  };
};

// wallet/limits

export enum OperationsEnum {
  sell = 'sell',
  withdraw = 'withdraw',
  buy = 'buy',
}

export type WalletLimitsType = {
  [key in GlobalTypes.CurrencyEnum]?: {
    init_day: string;
    day: string;
    max: string;
    min: string;
    init_month: string;
    month: string;
    init_week: string;
    week: string;
  };
};

export type GETWalletLimitsParams = {
  crypto_currency?: GlobalTypes.CurrencyEnum;
  currency?: GlobalTypes.CurrencyEnum;
  type?: OperationsEnum;
};

export type GETWalletLimitsResponse = {
  [key in OperationsEnum]: WalletLimitsType;
};

export enum PeriodsEnum {
  day = 'day',
  week = 'week',
  month = 'month',
}

export type TLimits = {
  [key in OperationsEnum]: {
    [period in PeriodsEnum]?: {
      value: string;
      init_value: string;
      fiat_value: string;
      fiat_init_value: string;
      title: string;
    };
  };
};

// wallet/exchange/rate ???

// topup/address

export type GetTopupAddressParams = {
  currency: GlobalTypes.CryptoCurrencyEnum;
};

export type GetTopupAddressResponse = {
  id: string;
  created_at: string;
  updated_at: string;
  currency: string;
  address: string;
};

// wallet/rapyd/methods

export type GetRapydPaymentMethodsResponse = {
  methods: {
    type: string;
    name: string;
    image: string;
  }[];
};
